import React, { useCallback } from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";

function CartItemsInCart({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    subtotal,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(item._id);
  }, [removeItem, item._id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;

      console.log(newQuantity);
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <tr className="tf-cart-item file-delete">
      <td className="tf-cart-item_product">
        <Link to={slug} className="img-box">
          <img src={image} alt="Cart Item" />
        </Link>
        <div className="cart-info">
          <Link to={slug} className="text-md fw-medium text-decoration-none text-dark">
            {title}
          </Link>
          <div className="variants">{variantName}</div>
          <span className="remove-cart link remove" onClick={handleRemove}>
            Remove
          </span>
        </div>
      </td>
      {/* <td className="tf-cart-item_price text-center" data-cart-title="Price">
        {!isNaN(numMrp) && (
          <span className="cart-price price-on-sale text-md text-decoration-line-through">
            ₹s{numMrp.toFixed(2)}/-
          </span>
        )}
      </td> */}
      <td className="tf-cart-item_price text-center" data-cart-title="Price">
  {!isNaN(numMrp) && numMrp > numPrice && (
    <span className="cart-price price-on-sale text-md text-decoration-line-through">
      ₹{numMrp.toFixed(2)}/-
    </span>
  )}
</td>
      <td className="tf-cart-item_price text-center" data-cart-title="Price">
        <span className="cart-price price-on-sale text-md fw-medium">
          ₹{numPrice.toFixed(2)}/-
        </span>
      </td>
      <td className="tf-cart-item_quantity" data-cart-title="Quantity">
        <div className="wg-quantity">
          <span
            className="btn-quantity btn-decrease"
            onClick={() => handleQuantityChange(-1)}
          >
            -
          </span>
          <input
            className="quantity-product"
            type="text"
            value={quantity}
            readOnly
          />
          <span
            className="btn-quantity btn-increase"
            onClick={() => handleQuantityChange(+1)}
          >
            +
          </span>
        </div>
      </td>
      <td className="tf-cart-item_total text-center" data-cart-title="Total">
        <div className="cart-total total-price text-md fw-medium">
          ₹{subtotal.toFixed(2)}/-
        </div>
      </td>
    </tr>
  );
}

export default CartItemsInCart;
